import {getTypes} from './Types';
export const fetchTypes = async (setTypes, domain) => {
    try{
        const requested = await getTypes(domain);
        setTypes(requested);
    }catch(e){
        console.error(e);
        setTypes({});
    }   
}